<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="sourcebilldata" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<sourcebilldata-form :data="currentrow" ref="sourcebilldataForm" @submit="sourcebilldataFormSubmit"
					@modalhide="sourcebilldataHide" />
			</el-main>
		</el-container>
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}

	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}

	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;

	}

	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>

	import listMixins from '@_system/components/base/mixins/list/list.js'
	import sourcebilldataForm from '../../lib/sourcebilldata/form'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				loading: false,
				foreingKey: {},
				currentrow: {},
				list_formConfig: [{
					field: 'billtype',
					title: '账单类型',
					span: 4,
					itemRender: {
						name: '$input',
						props: {}
					}
				},{
					field: 'billtime',
					title: '账单时间',
					span: 4,
					itemRender: {
						name: '$datePicker',
						props: {
							type:'daterange'
						}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page, updateForm, other) {
				console.log(page, updateForm, other)
				return new Promise(resolve => {
					this.$api.sourcebilldata.list({
						...page,
						...updateForm,
						...other,
					}).then((res) => {
						resolve(res)
					}, () => {
						this.loading = false
					})
				})
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.id = 'sourcebilldata_list'
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 2000, 5000],
				}
				gridOptions.columns = [{
						field: 'billtime',
						title: '账单时间',
						formatter: ({
							cellValue
						}) => {
							return window.systemMethods.timestampToDate(cellValue, true)
						},
					},
					{
						field: 'billtype',
						title: '账单类型',
						props: {
							show: true
						}
					},
					{
						field: 'mark',
						title: '备注',
						render: '',
						props: {
							show: true
						}
					},
					{
						field: 'status',
						title: '同步状态',
						render: '',
						props: {
							show: true,
						},
						slots: {
							default: ({
								row
							}) => {
								if (row.status == 1) {
									return '已同步'
								} else if (row.status == 2) {
									return '部分同步'
								} else {
									return '未同步'
								}
							}
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 160,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.uploadjindie(row)}}>同步金蝶</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.checkboxConfig = null
				gridOptions.toolbarConfig.buttons = [{
					name: '新建',
					status: 'primary',
					code: 'add'
				}]
			},
			uploadjindie(row) {

				
				this.$confirm('是否确认同步 ' + (row.code ? row.code : ''), '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.sourcebilldata.uploadjindie({
						id: row.id
					}).then(() => {
						this.loading = false
						this.$message.success('操作成功')
						this.customreload()
					}, () => {
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})

			},
			add() {
				this.$refs.sourcebilldataForm.modal_show()
			},
			edit(row) {
				this.currentrow = row
				this.$nextTick(() => {
					this.$refs.sourcebilldataForm.modal_show()
				})
			},
			del(row) {
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.sourcebilldata.delete(row.id).then(() => {
						this.loading = false
						this.customreload()
					}, () => {
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			sourcebilldataFormSubmit() {
				this.customreload()
			},
			sourcebilldataHide() {
				this.currentrow = {}
			},
			customreload() {
				this.$refs.sourcebilldata.commitProxy('query')
			}
		},
		components: {
			sourcebilldataForm
		}
	}
</script>